import React from 'react';
import { MotionConfig } from 'framer-motion';
import { Toaster } from 'sonner';
import { PrototypeProvider, useProto } from './contexts/PrototypeContext';
import { PrototypeBar } from './components/prototype/PrototypeBar';
import { ScenarioPanel } from './components/prototype/ScenarioPanel';
import { ConnectShell } from './components/connect/ConnectShell';
import { CustomerCanvas } from './components/customer/CustomerCanvas';
function PrototypeLayout() {
  const {
    state
  } = useProto();
  return <div className="flex h-screen w-full flex-col bg-proto-canvas" data-id="element-0" data-mp="2mmlut5zds75b">
      <PrototypeBar data-id="element-1" data-mp="31aqfuglwour9" />
      <div className="flex min-h-0 flex-1" data-id="element-2" data-mp="31b8lg3ugklbu">
        <ScenarioPanel data-id="element-3" data-mp="31c1ha9rvpqf7" />
        <main className="min-w-0 flex-1" data-id="element-4" data-mp="31cjk5p91r2w3">{state.view === 'connect' ? <ConnectShell data-id="element-5" data-mp="2wiferaffj2x4" /> : <CustomerCanvas data-id="element-6" data-mp="2wip2ssgwz006" />}</main>
      </div>
    </div>;
}
export function App() {
  return <MotionConfig reducedMotion="user" data-id="element-7" data-mp="28sl5t3y8dyi5">
      <PrototypeProvider data-id="element-8" data-mp="23vkzcrxgytqi">
        <PrototypeLayout data-id="element-9" data-mp="23u9vyt7xrnzx" />
        <Toaster position="bottom-right" richColors data-id="element-10" data-mp="23v2sl1d6kx4c" />
      </PrototypeProvider>
    </MotionConfig>;
}